// extracted by mini-css-extract-plugin
module.exports = {"header":"BaseWidget_header__Bg3YP","name":"BaseWidget_name__1tjuH","scroll":"BaseWidget_scroll__34vKh"};